import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=51942724&"
import script from "./InvoiceList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports